import { Component, Injector, ViewEncapsulation, ViewChild, OnInit } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { HttpClient } from '@angular/common/http';
import { AppConsts } from '@shared/AppConsts';
import { finalize } from 'rxjs/operators';
import { appModuleAnimation } from '@shared/animations/routerTransition';

@Component({
  selector: 'app-change-crystal-report',
  templateUrl: './change-crystal-report.component.html',
      encapsulation: ViewEncapsulation.None,
      animations: [appModuleAnimation()],
      standalone: false,
})
export class ChangeCrystalReportComponent {
  AppConsts = AppConsts;
  uploadedFileName: string = '';
  saving = false;
  saveButtonDisabled = true;
  loading = false;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    this.uploadedFileName = this.config.data?.crystalReportPath || '';
  }

  onUpload(event: any): void {
    const response = event.originalEvent?.body;
    if (response?.success) {
      this.uploadedFileName = response.result.filePath
        .split('\\Reports\\')[1]
        ?.substring(1) || '';
      this.saveButtonDisabled = false;
    }
  }

  download(): void {
    const url = `${AppConsts.remoteServiceBaseUrl}/File/DownloadCrystalReportPath?filepath=${encodeURIComponent(this.uploadedFileName)}`;
    window.open(url, '_blank');
  }

  clearReport(): void {
    this.loading = true;
    this.http
      .delete(
        `${AppConsts.remoteServiceBaseUrl}/File/DeleteCrystalReport?filepath=${this.uploadedFileName}`
      )
      .pipe(finalize(() => (this.loading = false)))
      .subscribe(() => {
        this.uploadedFileName = 'SalesInvoice.rpt';
        this.ref.close(this.uploadedFileName);
      });
  }

  save(): void {
    if (!this.uploadedFileName) {
      this.uploadedFileName = 'SalesInvoice_New.rpt';
    }
    this.ref.close(this.uploadedFileName);
  }

  cancel(): void {
    this.ref.close(null);
  }
}
